module.exports = __webpack_public_path__ + "static/media/17.fe84bdf1.jpg";